import { Storage } from '../Storage';
import { third_json_handler, mobileHideHandler, parseStatusDic, fileStatusDic } from './constant';
export const getUserId = (needLogin = false) => {
    // 未登录取本地id
    let ouid = Storage.get('ouid');
    let userInfo = Storage.get('userInfo');
    let data = {};
    if (userInfo) {
        data = JSON.parse(userInfo);
    }
    if (needLogin) {
        return data?.id;
    }
    return data?.id || ouid;
};

//后端暂定
//1-外部场景
export const getSkillList = (scene_setting, scene_id = '1', isLogin) => {
    if (!scene_setting) {
        return [];
    }
    //获取指定场景列表
    let targetScene = scene_setting.find((item) => item.scene_id === scene_id);
    if (targetScene) {
        let data = targetScene.ability_list;
        // 如果未登录  只保留可未登录使用的技能
        // if (!isLogin) {
        //     data = data.filter((ele) => ele.login_restrict === 0);
        // }

        return (
            data.sort((a, b) => {
                return a.sort - b.sort;
            }) || []
        );
    }
    return [];
};
export const getSkillPluginNames = (plugin) => {
    return plugin?.map((ele) => ele.name) || [];
};
export const getRoles = (isLoading, aiImg, localImg) => {
    return {
        ai: {
            avatar: aiImg ? aiImg : null,
            placement: 'start',
            // typing: isLoading ? { step: 10, interval: 30 } : false,
            typing: false,
            styles: {
                content: {
                    borderRadius: 16
                }
            }
        },
        local: {
            avatar: localImg ? localImg : null,
            placement: 'end',
            variant: 'borderless',
            footer: null
        }
    };
};
export const getMobileHideSkills = () => {
    return mobileHideHandler;
};

//技能分组
export const handleSkillGroup = (skillList, toolList = [], side) => {
    let mobileHideSkills = getMobileHideSkills();
    //移动端隐藏技能

    if (side === 'mobile') {
        skillList = skillList.filter((ele) => {
            return !mobileHideSkills.includes(ele?.third_json?.handler);
        });
    }
    let apartList = [],
        unApartList = [];
    skillList.forEach((ele) => {
        if (ele.ability_id === '-1') {
            ele.ability_id = -1;
        }

        ele.ability_name = ele.show_name;
        ele.description = ele.show_description;

        // if (ele?.third_json?.handler === third_json_handler.recommend_course) {
        //     ele.default_prompt = '请帮我推荐一些关于 [在这里填写你的兴趣主题] 的课程';
        // }
        if (ele.left_side === 1) {
            ele.apart = true;
            apartList.push(ele);
        }
        if (ele.left_side === 2) {
            unApartList.push(ele);
        }
    });
    apartList = apartList.sort((a, b) => a.sort - b.sort);
    unApartList = unApartList.sort((a, b) => a.sort - b.sort);
    return {
        apartList,
        unApartList
    };
};
export const isApartSkillActive = (curSkill, item, isNewChat, isMobile = true) => {
    if (!isMobile && !isNewChat) {
        return false;
    }
    if (curSkill?.ability_id != -1 && !curSkill?.apart) {
        return item.ability_id == -1;
    }
    return curSkill?.ability_id == item.ability_id;
};
//dom横向滚动到可视区域
export const changeHorizonDomIntoView = (targetDom, containerDom) => {
    if (!targetDom) {
        return false;
    }
    let domWidth = targetDom.clientWidth;
    let ulWidth = containerDom.clientWidth;
    let diffWidth = targetDom.offsetLeft + domWidth - ulWidth;

    if (diffWidth > 0) {
        containerDom.scrollTo({
            left: diffWidth + 60,
            behavior: 'smooth'
        });
    } else {
        containerDom.scrollTo({
            left: diffWidth,
            behavior: 'smooth'
        });
    }
};

export const handleStyle = (styleConfig) => {
    let themeColor = 1,
        webBgUrl = null,
        h5BgUrl = null;
    if (styleConfig) {
        if (styleConfig?.theme_color) {
            themeColor = styleConfig?.theme_color;
        }
        let {
            pc_back_ground_type = 1,
            pc_back_ground_custom,
            pc_back_ground_preset,
            h5_back_ground_type = 1,
            h5_back_ground_custom,
            h5_back_ground_preset
        } = styleConfig;
        webBgUrl = pc_back_ground_type === 1 ? pc_back_ground_preset : pc_back_ground_custom;
        h5BgUrl = h5_back_ground_type === 1 ? h5_back_ground_preset : h5_back_ground_custom;
    }
    return {
        webBgUrl,
        h5BgUrl,
        themeColor
    };
};

export const changeFavicon = (href) => {
    if (!href) {
        return false;
    }
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = href;
    document.getElementsByTagName('head')[0].appendChild(link);
};
export const getFileStatus = (agentFile) => {
    let inUpload = [],
        uploadSuccess = [];
    agentFile.forEach((ele) => {
        if (ele.status === fileStatusDic.ing) {
            inUpload.push(ele);
        }
        if (ele.status === fileStatusDic.success) {
            //解析中
            if (ele.parse_status !== undefined && ele.parse_status === parseStatusDic.ing) {
                inUpload.push(ele);
            }
            if (ele.parse_status === parseStatusDic.success) {
                uploadSuccess.push(ele);
            }
        }
    });

    return {
        inUpload,
        uploadSuccess
    };
};
// export const getFileStatus = (agentFile) => {
//     let inUpload = [],
//         uploadSuccess = [];
//     agentFile.forEach((ele) => {
//         if (ele.status !== 2) {
//             inUpload.push(ele);
//         } else {
//             if (ele.parse_status !== undefined && ele.parse_status !== parseStatusDic.success) {
//                 inUpload.push(ele);
//             }
//             uploadSuccess.push(ele);
//         }
//     });
//     return {
//         inUpload,
//         uploadSuccess
//     };
// };
